import React from 'react';
import { BookOpen, Users, Award } from 'lucide-react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import BentoWidgetCard, { WidgetQuestion } from '../BentoWidgetCard';
import { getLMSPulseData } from '../../../../utils/aiBriefingsData';
interface LMSPulseWidgetProps {
  onExpand?: () => void;
  onHide?: () => void;
  onAsk?: (question: string) => void;
}
const LMSPulseWidget: React.FC<LMSPulseWidgetProps> = ({
  onExpand,
  onHide,
  onAsk
}) => {
  const data = getLMSPulseData();
  const questions: WidgetQuestion[] = [{
    id: '1',
    text: 'Perché alto drop-off?'
  }, {
    id: '2',
    text: 'Come migliorare engagement?'
  }, {
    id: '3',
    text: 'Moduli da ottimizzare?'
  }];
  return <BentoWidgetCard id="lms-pulse" title="LMS Learning Pulse" size="L" lastUpdated="6 min fa" questions={questions} onExpand={onExpand} onHide={onHide} onAsk={onAsk} data-id="element-1444">
      <div className="grid grid-cols-3 gap-3 mb-4" data-id="element-1445">
        <div className="bg-blue-50 rounded-lg p-3" data-id="element-1446">
          <Users className="h-5 w-5 text-blue-600 mb-2" data-id="element-1447" />
          <p className="text-xs text-blue-700" data-id="element-1448">Utenti Attivi</p>
          <p className="text-xl font-bold text-blue-900" data-id="element-1449">
            {data.activeUsers.toLocaleString()}
          </p>
        </div>
        <div className="bg-green-50 rounded-lg p-3" data-id="element-1450">
          <Award className="h-5 w-5 text-green-600 mb-2" data-id="element-1451" />
          <p className="text-xs text-green-700" data-id="element-1452">Completamenti</p>
          <p className="text-xl font-bold text-green-900" data-id="element-1453">
            {data.completions.toLocaleString()}
          </p>
        </div>
        <div className="bg-purple-50 rounded-lg p-3" data-id="element-1454">
          <BookOpen className="h-5 w-5 text-purple-600 mb-2" data-id="element-1455" />
          <p className="text-xs text-purple-700" data-id="element-1456">Pass Rate</p>
          <p className="text-xl font-bold text-purple-900" data-id="element-1457">{data.passRate}%</p>
        </div>
      </div>

      <div className="h-32 mb-4" data-id="element-1458">
        <ResponsiveContainer width="100%" height="100%" data-id="element-1459">
          <LineChart data={data.trend} data-id="element-1460">
            <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" data-id="element-1461" />
            <XAxis dataKey="date" stroke="#6B7280" fontSize={10} hide data-id="element-1462" />
            <YAxis stroke="#6B7280" fontSize={10} data-id="element-1463" />
            <Tooltip contentStyle={{
            backgroundColor: '#FFFFFF',
            border: '1px solid #E5E7EB',
            borderRadius: '0.5rem',
            fontSize: '12px'
          }} data-id="element-1464" />
            <Line type="monotone" dataKey="value" stroke="#16A34A" strokeWidth={2} dot={false} data-id="element-1465" />
          </LineChart>
        </ResponsiveContainer>
      </div>

      <div data-id="element-1466">
        <p className="text-xs font-semibold text-gray-900 mb-2" data-id="element-1467">
          Moduli con Alto Drop-off
        </p>
        <div className="space-y-2" data-id="element-1468">
          {data.dropoffModules.map((module, index) => <div key={index} className="bg-red-50 border border-red-200 rounded-lg p-2" data-id="element-1469">
              <div className="flex items-center justify-between mb-1" data-id="element-1470">
                <p className="text-xs font-medium text-gray-900" data-id="element-1471">
                  {module.module}
                </p>
                <span className="text-xs font-bold text-red-600" data-id="element-1472">
                  {module.dropoffRate}%
                </span>
              </div>
              <p className="text-xs text-gray-600" data-id="element-1473">
                {module.enrollments} iscritti
              </p>
            </div>)}
        </div>
      </div>
    </BentoWidgetCard>;
};
export default LMSPulseWidget;